import { Eye, EyeOff } from 'lucide-react';

import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from '@/components/ui/input-group';
import { Label } from '@/components/ui/label';

type PasswordInputProps = {
  id: string;
  name: string;
  label: string;
  placeholder: string;
  defaultValue?: string;
  value?: string;
  showPassword: boolean;
  onChange?: (value: string) => void;
  onToggleVisibility: () => void;
  required?: boolean;
};

export const PasswordInput = ({
  id,
  name,
  label,
  placeholder,
  defaultValue,
  value,
  showPassword,
  onChange,
  onToggleVisibility,
  required,
}: PasswordInputProps) => (
  <div className="space-y-2">
    <Label htmlFor={id} required={required}>
      {label}
    </Label>
    <InputGroup>
      <InputGroupInput
        id={id}
        type={showPassword ? 'text' : 'password'}
        name={name}
        placeholder={placeholder}
        defaultValue={defaultValue}
        value={value}
        onChange={(event) => onChange?.(event.target.value)}
        autoComplete="current-password"
        required={required}
      />
      <InputGroupAddon align="inline-end">
        <InputGroupButton
          type="button"
          variant="ghost"
          onClick={onToggleVisibility}
        >
          {showPassword ? <EyeOff /> : <Eye />}
        </InputGroupButton>
      </InputGroupAddon>
    </InputGroup>
  </div>
);
